import React from 'react'
import { connect } from 'react-redux'
import { graphql, compose } from 'react-apollo'
import { string, func, shape } from 'prop-types'
import { getFormValues, change } from 'redux-form'
import { qlmExecuteFunction } from 'crm-data/crm'
import { qlqProcessTypes } from 'crm-data/processes'
import { qlqfetchAccount } from 'crm-data/accounts'
import { qlqAccountTasks } from 'crm-data/tasks'
import uuidv4 from 'uuid'
import crmGenericCommandQlHoc, {
  cqCommandPropTypes
} from 'crm-components/ql/crm-generic-command-ql-hoc.jsx'
import { getAccountOwnerUserUid } from 'crm-utils/accounts-utils'

const newOwnerOptions = [
  { value: 'user', label: 'User' },
  { value: 'group', label: 'Group' }
]

export const generateCommandFromForm = (
  formValues,
  props,
  accountUid,
  souceProcessUid,
  isBulkMode = false
) => {
  console.log('handleSave Convert to prospect')
  if (!formValues) {
    throw new Error('Error - no formValues!')
  }
  if (!formValues.campaign_uid) {
    throw new Error('Select Sale Campaign')
  }
  if (!formValues.process_type_uid) {
    throw new Error('Select Process Type')
  }
  if (!formValues.owner_type) {
    throw new Error('Select new owner type')
  }
  if (formValues.owner_type === 'user' && !formValues.owner_user_uid) {
    throw new Error('Select new owner')
  }
  if (formValues.owner_type === 'group' && !formValues.owner_pool_uid) {
    throw new Error('Select users group')
  }
  const process = {
    account_uid: accountUid,
    owner_type: formValues.owner_type,
    campaign_uid: formValues.campaign_uid,
    opportunity_type_uid: 'bd76af36-fc69-4bf6-9a97-6ed64f56af73',
    source_process_uid: souceProcessUid,
    process_type_uid: formValues.process_type_uid
  }
  if (isBulkMode) {
    process.is_bulk_mode = true
  }
  if (formValues.owner_type === 'user') {
    process.owner_user_uid = formValues.owner_user_uid
  } else if (formValues.owner_type === 'group') {
    process.owner_pool_uid = formValues.owner_pool_uid
  } else {
    throw new Error('Unknown process owner type')
  }
  const command = {
    type: 'process.start',
    aggregate_uid: isBulkMode ? uuidv4() : props.newObjectUid,
    aggregate_type: 'process',
    payload: {
      process
    }
  }
  console.log('Returning command')

  return command
}

export function calculateInitialValues(props) {
  const accountOwnerUid = props.account
    ? getAccountOwnerUserUid(props.account)
    : undefined
  const initialValues = {
    owner_user_uid: accountOwnerUid,
    campaign_uid:
      props.account && props.account.lead_campaign
        ? props.account.lead_campaign.marketing_campaign_uid
          ? props.account.lead_campaign.marketing_campaign_uid
          : props.account.lead_campaign.campaign_uid
        : undefined,
    owner_type: 'user'
  }
  initialValues.process_type_uid = 'e30eb792-2832-4c10-9f74-2c6b1df1318e'
  return initialValues
}
const convertToProspectHOC = WrappedComponent => {
  class Inner extends React.PureComponent {
    static propTypes = {
      ...cqCommandPropTypes,
      accountUid: string.isRequired,
      qlmExecuteFunction: func.isRequired,
      account: shape().isRequired
    }
    setStateAsync = newState =>
      new Promise(resolve => {
        this.setState(newState, () => {
          resolve()
        })
      })

    constructor(props) {
      super(props)

      console.log('Conver to prospect ql hoc constructor')
      const initialValues = calculateInitialValues(props)
      const state = {
        initialValues,
        noDefaultSaleCampaignError:
          props.account &&
          props.account.campaign &&
          !props.account.campaign.marketing_campaign_uid,
        isShowingMoreOptions: false,
        requireSelectTransactionType:
          props && props.account && !props.account.category,
        thisUid: uuidv4()
      }

      this.state = state
      this.bulkQueue = [];
    }

    componentDidMount() {
      if (this.props.isNested) {
        const initialValues = calculateInitialValues(this.props)
        Object.keys(initialValues).forEach(key => {
          this.props.doChange(
            this.props.form,
            'dispositionDetailsForm.' + key,
            initialValues[key]
          )
        })
      }
    }

    handleSave = async (pAccount = undefined, isBulkMode = false) => {
      /*
 *       console.log('handleSave', pAccount, this.props)
 *
 *             if (isBulkMode) {
 *                     const randomSeconds = Math.floor(Math.random() * 4) + 2;
 *                             console.log(`[Bulk Mode] Delaying request for ${randomSeconds} seconds...`);
 *                                     await new Promise(resolve => setTimeout(resolve, randomSeconds * 1000));
 *                                           }*/

      const accountUid = pAccount ? pAccount.account_uid : this.props.accountUid

      let souceProcessUid
      if (pAccount) {
        souceProcessUid = pAccount.process_uid
      } else {
        souceProcessUid = this.props.sourceProcess
          ? this.props.sourceProcess.process_uid
          : undefined
      }

      const command = generateCommandFromForm(
        this.props.formValues,
        this.props,
        accountUid,
        souceProcessUid,
        isBulkMode
      )
      console.log('Have command', command)
      try {
        const refetchQueries = pAccount
          ? []
          : [
              {
                query: qlqfetchAccount,
                variables: { account_uid: accountUid }
              },
              {
                query: qlqAccountTasks,
                variables: { account_uid: accountUid }
              }
            ]
        console.log('Run onRunCommand')
        const res = await this.props.onRunCommand(command, { refetchQueries })
        console.log('Res', res)
        return {
          status: 'OK',
          process: res.data.cqCommand.payload
            ? res.data.cqCommand.payload.process
            : undefined
        }
      } catch (err) {
        throw new Error(err)
      }
    }

    handleUserSelect = value => {
      this.setState({ user: value })
    }

    handleCampaignChanged = campaign_uid => {
      this.setState({ campaign_uid })
    }
    handleowner_typeChange = owner_type => {
      this.setState({ owner_type })
    }
    handleUsersGroupSelect = usersGroup => {
      this.setState({ usersGroup })
    }
    handleProcessTypeChange = process_type_uid => {
      this.setState({ process_type_uid })
    }
    handleToggleShowMoreOptions = () => {
      this.setState({ isShowingMoreOptions: !this.state.isShowingMoreOptions })
    }

    handleBulkOperation = async pAccount => {
      const res = await this.handleSave(pAccount, true)
      return res
    }

    handleBulkOperationQueue = (pAccount) => {
      console.log('Convert to prospect HOC - Queuing account', pAccount.account_uid)
      this.bulkQueue.push(pAccount);
      return { status: 'QUEUED' };
    }

    handleBulkOperationFlush = async (onProgressCallback) => {
      const accountsList = this.bulkQueue;
      if (accountsList.length === 0) return { status: 'OK', processed: 0 };

      console.log('Convert to prospect HOC - Flushing queued accounts', accountsList.length)

      const chunkSize = 5;
      let totalProcessed = 0;

      for (let i = 0; i < accountsList.length; i += chunkSize) {
        const chunk = accountsList.slice(i, i + chunkSize);

        const chunkUids = chunk.map(pAccount => pAccount.account_uid);

        if (onProgressCallback) {
          await onProgressCallback(chunkUids, 'processing');
        }

        const bulkPayloads = chunk.map(pAccount => {
          const command = generateCommandFromForm(
              this.props.formValues,
              this.props,
              pAccount.account_uid,
              pAccount.process_uid,
              true
          );
          return {
            aggregate_uid: command.aggregate_uid,
            ...command.payload.process
          };
        });

        const bulkCommand = {
          command_uid: uuidv4(),
          type: 'process.startBulk',
          aggregate_type: 'process',
          aggregate_uid: uuidv4(),
          payload: { processes: bulkPayloads }
        };

        try {
          const delaySeconds = Math.floor(Math.random() * 2) + 1;
          console.log(`[Chunk ${i/chunkSize + 1}] Waiting ${delaySeconds} seconds before sending...`);
          await new Promise(resolve => setTimeout(resolve, delaySeconds * 1000));

          const res = await this.props.onRunCommand(bulkCommand, { refetchQueries: [] });

          if (res.data && res.data.cqCommand && res.data.cqCommand.payload) {
            totalProcessed += res.data.cqCommand.payload.processed_count || chunk.length;
          }
          console.log(`Processed chunk ${i/chunkSize + 1}, Total: ${totalProcessed}/${accountsList.length}`);

          if (onProgressCallback) {
            await onProgressCallback(chunkUids, 'success');
          }

        } catch (err) {
          console.error("Error processing bulk chunk", err);
          if (onProgressCallback) {
            await onProgressCallback(chunkUids, 'error');
          }
          throw new Error(err);
        }
      }

      this.bulkQueue = [];
      return { status: 'OK', processed: totalProcessed };
    }

    render() {
      const processTypeOptions =
        this.props.qlqProcessTypes && this.props.qlqProcessTypes.process_types
          ? this.props.qlqProcessTypes.process_types
              .filter(p => p.kind === 'prospect' || p.kind === 'dialer')
              .filter(p =>
                this.props.newProcessKind
                  ? p.kind === this.props.newProcessKind
                  : true
              )
              .map(p => ({
                value: p.process_type_uid,
                name: p.name
              }))
          : []

      return (
        <WrappedComponent
          {...this.props}
          campaign_uid={this.state.campaign_uid}
          user={this.state.user}
          owner_type={this.state.owner_type}
          onSave={this.handleSave}
          process_type_uid={this.state.process_type_uid}
          onUserSelect={this.handleUserSelect}
          onCampaignChanged={this.handleCampaignChanged}
          onowner_typeChanged={this.handleowner_typeChange}
          onUserGroupSelect={this.handleUsersGroupSelect}
          onProcessTypeChange={this.handleProcessTypeChange}
          newOwnerOptions={newOwnerOptions}
          newProcessKind={this.props.newProcessKind}
          processTypeOptions={processTypeOptions}
          initialValues={this.state.initialValues}
          formValues={this.props.formValues}
          noDefaultSaleCampaignError={this.state.noDefaultSaleCampaignError}
          isShowingMoreOptions={this.state.isShowingMoreOptions}
          onToggleShowMoreOptions={this.handleToggleShowMoreOptions}
          requireSelectTransactionType={this.state.requireSelectTransactionType}
          onBulkOperation={this.handleBulkOperationQueue}
          onBulkOperationFlush={this.handleBulkOperationFlush}
        />
      )
    }
  }
  return connect(
    (state, ownProps) => {
      const formName = ownProps.form ? ownProps.form : 'convertToProspect'
      const formValues = getFormValues(formName)(state)
      const resultFormValues =
        ownProps.isNested && formValues
          ? formValues.dispositionDetailsForm
          : formValues
      return {
        formValues: resultFormValues
      }
    },
    dispatch => ({
      doChange: (formName, field, value) =>
        dispatch(change(formName, field, value))
    })
  )(crmGenericCommandQlHoc(Inner))
}

const convertToProspectQLHOC = compose(
  graphql(qlmExecuteFunction, {
    name: 'qlmExecuteFunction',
    options: ownProps => ({
      refetchQueries: [
        {
          query: qlqfetchAccount,
          variables: { account_uid: ownProps.accountUid }
        }
      ]
    })
  }),
  graphql(qlqProcessTypes, {
    name: 'qlqProcessTypes'
  }),
  convertToProspectHOC
)

export default convertToProspectQLHOC

